export default "__VITE_ASSET__Cb887vco__"